module.exports = __webpack_public_path__ + "static/media/member5.110e8511.jpg";